import React from 'react';
import MemberProfileModal from './MemberProfileModal';

const ADMIN_ARTIST_PAGE_URL = (artistId) => `/admin/workspaces/artist-management/artists/${artistId}`;

export function AdminMemberProfileModal(props) {
  return (
    <MemberProfileModal
      {...props}
      allowArtistLink={props.allowArtistLink ?? true}
      resolveArtistDetailUrl={ADMIN_ARTIST_PAGE_URL}
    />
  );
}

export function ArtistMemberProfileModal(props) {
  return (
    <MemberProfileModal
      {...props}
      allowArtistLink={props.allowArtistLink ?? false}
    />
  );
}
